import React from "react";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function TransferError() {
  const navigate = useNavigate();
  return (
    <Container className="flex flex-col items-center justify-center min-h-screen text-center py-12">
      <div className="bg-white rounded-2xl shadow-md p-10 max-w-md w-full">
        <div className="text-5xl mb-4">❌</div>
        <h1 className="text-2xl font-bold text-red-700 mb-2">Submission Failed</h1>
        <p className="text-gray-600 mb-6">
          Something went wrong. Please try again or contact support.
        </p>
        <button
          onClick={() => navigate("/transfer")}
          className="px-6 py-2 bg-blue-700 text-white rounded-xl hover:bg-blue-800 transition"
        >
          Try Again
        </button>
      </div>
    </Container>
  );
}
